<!--
 * @Description: 
 * @Author: zml
 * @Date: 2023-03-21 11:49:51
 * @LastEditors: zml
 * @LastEditTime: 2023-11-10 15:22:34
-->
<template>
  <el-dialog @close="close" :visible="visible" :close-on-click-modal="false" width="1000px" append-to-body>
    <div class="login-title">
      <div class="title">{{$hs('更新信息','Update information','Actualización de la información')}}</div>
    </div>
    <div class="form-box">
      <el-form :model="formData" ref="formData" label-position="right" label-width="175px" :rules="rules">
        <!-- <div class="row"> 用户名
          <el-form-item prop="userAccount" :label="$t('LLH.UserAccount') + ':'">
            <el-input ref="userAccount" v-model="formData.userAccount" @blur="userAccountBlur"></el-input>
            <span class="describe">
              <span
                style="color: red;"
                v-if="isUserAccount"
              >{{ $hs('用户名已存在','User name already exists','El nombre de usuario ya existe') }}&nbsp;&nbsp;</span>
              <span>{{$t('LLH.LoginOnly')}}</span>
            </span>
          </el-form-item>
        </div>-->
        <div class="row">
          <el-form-item prop="email" :label="$t('LLH.Email') + ':'" required>
            <el-input ref="inputEmail" v-model="formData.email" :disabled="true"></el-input>
            <!-- <span class="describe">{{$t('LLH.EmailMsg')}}</span> -->
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item prop="userName" :label="$t('LLH.Name') + ':'" required>
            <el-input v-model="formData.userName"></el-input>
            <span class="describe">{{ $t('LLH.NameMsg') }}</span>
          </el-form-item>
        </div>
        <!-- <div class="row">
          <el-form-item prop="userPassword" :label="$t('LLH.password') + ':'" required>
            <el-input type="password" v-model="formData.userPassword" autocomplete="off"></el-input>
            <span class="describe">{{$t('LLH.passwordMsg')}}</span>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item prop="userPasswordVerify" :label="$t('LLH.confirmPassword') + ':'" required>
            <el-input type="password" v-model="formData.userPasswordVerify" autocomplete="off"></el-input>
            <span class="describe">{{$t('LLH.requiredFields')}}</span>
          </el-form-item>
        </div>-->
        <div class="row">
          <el-form-item prop="gender" :label="$t('LLH.gender') + ':'" required>
            <el-radio-group v-model="formData.gender" style="width:350px">
              <el-radio :label="1">{{$t('LLH.man')}}</el-radio>
              <el-radio :label="2">{{$t('LLH.woman')}}</el-radio>
              <el-radio :label="0">{{$hs('保密','Secrecy','Confidencialidad')}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item prop="source" :label="$t('LLH.customerSource') + ':'">
            <!-- <el-input v-model="formData.source" ></el-input> -->
            <el-select allow-create filterable default-first-option clearable v-model="formData.source" placeholder @blur="sourceBlur">
              <el-option v-for="(item, index) in sourceList" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item prop="sysUserId" :label="$t('LLH.salesman') + ':'">
            <el-select v-model="formData.sysUserId" placeholder="NONE" :disabled="true">
              <el-option v-for="(item, index) in userList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item prop="sysUserEmail" :label="$hs('销售员邮箱','Salesperson email','Buzón del vendedor') + ':'">
            <el-input v-model="formData.sysUserEmail" :disabled="true"></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item prop="country" :label="$t('LLH.Country') + ':'" required>
            <el-input v-model="formData.country"></el-input>
            <span class="describe">{{$t('LLH.requiredFields')}}</span>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item prop="company" :label="$t('LLH.companyName') + ':'" required>
            <el-input v-model="formData.company"></el-input>
            <span class="describe">{{$t('LLH.requiredFields')}}</span>
          </el-form-item>
        </div>
        <!-- <div class="row"> 职务
          <el-form-item prop="job" :label="$t('LLH.duty') + ':'">
            <el-input v-model="formData.job"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <div class="row">
          <el-form-item prop="tel" :label="$t('LLH.tel') + ':'" required>
            <el-input v-model="formData.tel"></el-input>
            <span class="describe">{{$t('LLH.requiredFields')}}</span>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item prop="weChat" :label=" $t('LLH.WeChat') + ':'">
            <el-input v-model="formData.weChat"></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item prop="whatsApp" :label="'WhatsApp' + ':'">
            <el-input v-model="formData.whatsApp"></el-input>
          </el-form-item>
        </div>

        <!-- <div class="row"> 手机号
          <el-form-item prop="mobile" :label="$t('LLH.mobile') + ':'">
            <el-input v-model="formData.mobile"></el-input>
            <span class="describe">{{$t('LLH.requiredFields')}}</span>
          </el-form-item>
        </div>-->
        <!-- <div class="row"> 传真
          <el-form-item prop="fax" :label="$t('LLH.fax') + ':'">
            <el-input v-model="formData.fax"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <!-- <div class="row"> QQ
          <el-form-item prop="qq" :label="'QQ:'">
            <el-input v-model="formData.qq"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <!-- <div class="row"> MSN
          <el-form-item prop="msn" :label="'MSN:'">
            <el-input v-model="formData.msn"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <!-- <div class="row"> SKYPE
          <el-form-item prop="skype" :label="'SKYPE:'">
            <el-input v-model="formData.skype"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <!-- <div class="row"> 雅虎
          <el-form-item prop="yahu" :label="$t('LLH.Yahoo') + ':'">
            <el-input v-model="formData.yahu"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <!-- <div class="row"> 网站
          <el-form-item prop="website" :label="$t('LLH.website') + ':'">
            <el-input v-model="formData.website"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <!-- <div class="row"> 地址
          <el-form-item prop="address" :label="$t('LLH.address') + ':'">
            <el-input v-model="formData.address"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <!-- <div class="row"> 邮政编码
          <el-form-item prop="zipCode" :label="$t('LLH.postalCode') + ':'">
            <el-input v-model="formData.zipCode"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
      </el-form>
    </div>

    <span slot="footer">
      <div class="dialog-footer">
        <div>
          <!-- {{$t('LLH.ExistingAccount')}} ?
          <span style="cursor: pointer;color:#00923f;" @click="login">{{$t('LLH.DirectLogin')}}</span>-->
        </div>
        <div>
          <el-button type="primary" @click="signInFun" class="btn">{{$hs('确认更新','Confirm Update','Confirmar actualización')}}</el-button>
        </div>
      </div>
    </span>
  </el-dialog>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { GetMemberSourceList, GetUserList, VerifyEmail, IsExistUserAccount, GetMemberInfo, UpdateMember } from '@/api/login'
export default {
  name: 'loginModal',
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.formData.userPasswordVerify !== '') {
          this.$refs.formData.validateField('userPasswordVerify')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.formData.userPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      visible: false,
      codeData: {},
      formData: {
        gender: 0,
        source: '',
        job: '',
        company: '',
        tel: '',
        fax: '',
        qq: '',
        msn: '',
        skype: '',
        yahu: '',
        website: '',
        zipCode: '',
        country: '',
        userId: null,
        sysUserEmail: '',
        userAccount: '',
        userName: '',
        userPassword: '',
        userPasswordVerify: '',
        mobile: '',
        email: '',
        address: '',
        weChat: '',
        whatsApp: '',
        createdUserId: '',
        createdUserEmail: '',
        sysUserId: ''
      },
      rules: {
        userName: [
          { required: true, message: '姓名为必填', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        userPassword: [
          { validator: validatePass, trigger: 'blur' },
          { min: 6, max: 30, message: '长度在 6 到 30 个字符', trigger: 'blur' }
        ],
        userPasswordVerify: [{ validator: validatePass2, trigger: 'blur' }],

        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },
      sourceList: [],
      userList: [],
      isUserAccount: false
    }
  },
  computed: {
    ...mapState('operate', ['language']),
    ...mapState('user', ['userInfo'])
  },
  methods: {
    ...mapActions('user', ['set_userInfo']),
    open() {
      this.visible = true
      this.getUserInfo()
      this.getList()
    },

    close() {
      this.visible = false
      this.$refs.formData.resetFields()
    },

    sourceBlur(e) {
      this.formData.source = e.target.value
    },

    login() {
      this.close()
      this.$emit('login')
    },

    // 获取用户信息
    getUserInfo() {
      GetMemberInfo()
        .then(res => {
          if (res.success) {
            let info = res.data || {}
            this.formData = {
              ...this.formData,
              ...info.member,
              // createdUserId: info.member.createdUserId,
              // createdUserEmail: info.member.createdUserEmail
            }

            this.set_userInfo(res.data)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },

    // 获取数据
    getList() {
      GetMemberSourceList()
        .then(res => {
          if (res.success) {
            this.sourceList = res.data || []
          }
        })
        .catch(err => {
          this.$message.error(err)
        })

      GetUserList()
        .then(res => {
          if (res.success) {
            this.userList = res.data || []
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },

    verifyEmailFun(memberId) {
      VerifyEmail({
        email: this.formData.email,
        memberId: memberId
      }).then(res => {})
    },

    userAccountBlur() {
      IsExistUserAccount({
        userAccount: this.formData.userAccount
      }).then(res => {
        if (res.data) {
          this.isUserAccount = true
          this.$message.warning(this.$hs('用户名已存在', 'User name already exists', 'El nombre de usuario ya existe'))
          this.$refs.userAccount.focus()
          this.$refs.userAccount.select()
        } else {
          this.isUserAccount = false
        }
      })
    },

    // 注册
    signInFun() {
      let _this = this
      _this.$refs.formData.validate(values => {
        if (!values) {
          this.$message.warning(
            this.$hs(
              '更新失败，校验不通过，请检查填写数据',
              'Update failed, verification failed. Please check and fill in the data',
              'La actualización falló, la verificación no pasó, por favor verifique y rellene los datos'
            )
          )
          return
        }
        // 注册
        UpdateMember({
          ..._this.formData,
          userId: this.formData.userId ? this.formData.userId : 0,
          userAccount: this.formData.email
        })
          .then(res => {
            if (res.success) {
              _this.$message.success(_this.$hs('更新成功', 'update success', 'Actualización exitosa'))
              // _this.verifyEmailFun(res.data)

              _this.getUserInfo()
              _this.close()
            } else {
              _this.$message.error(res.message)
            }
          })
          .catch(err => {
            this.$message.error(JSON.stringify(err))
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-dialog__header) {
  text-align: left;
  padding: 0px;
  .el-dialog__headerbtn {
    z-index: 99;
  }
}
:deep(.el-dialog__body) {
  padding: 0 !important;
  .login-title {
    height: 62px;
    border-bottom: 1px solid #eee;

    .title {
      height: 62px;
      line-height: 62px;
      text-align: center;
      font-size: 24px;
      color: #222222;
    }
    .msg {
      text-align: center;
      font-size: 14px;
      color: #999999;
    }
  }

  .form-box {
    height: 500px;
    padding: 20px;
    overflow-y: auto;

    .row {
      display: flex;
      align-items: center;
      .el-form-item {
        margin-bottom: 12px !important;

        .el-input {
          width: 350px;
        }
        .describe {
          padding: 0 0 0 10px;
          font-size: 14px;
          color: #666666;
        }
      }
    }
  }

  .operation {
    padding: 0 40px 30px;
    font-size: 14px;
    color: #222222;
    display: flex;
    justify-content: space-between;
  }
}

:deep(.el-dialog__footer) {
  padding: 10px 60px;
  border-top: 1px solid #eee;
}
:deep .el-form {
  padding: 0 40px 0 0;
  .valide-code {
    .el-input {
      margin: 0 10px 0 0;
    }
    .el-form-item__content {
      display: flex;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  .btn {
    width: 866px;
    margin-bottom: 10px;
    background-color: #00923f;
    border-color: #00923f;
  }
}

:deep(.el-form-item__error) {
  display: none;
}
</style>